const Container = ({ children }) => {
  return <div className="w-container mx-auto">{children}</div>;
};

export default Container;
